import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React from "react";
import PropTypes from "prop-types";
import Firma from "../Firma";

const Empresa = ({ empresa, declaracion }) => {
  return (
    <Grid p={3}>
      <SoftTypography color="black" variant="h5" fontWeight="bold" mb={2}>
        DECLARACIÓN JURADA N° {declaracion?.id} - AÑO {declaracion?.anio}
      </SoftTypography>
      {empresa ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Razón Social: {empresa.razonSocial || "Sin información"}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Legajo: {empresa.id || "Sin información"}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Actividad: {declaracion.actividad || "Sin información"}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              CUIT: {empresa.cuit || "Sin información"}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Email: {empresa.email || "Sin información"}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Código de Actividad de AFIP: {empresa.codigoAfip || "Sin información"}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Gerente o apoderado: {empresa.gerente || "Sin información"}
            </SoftTypography>
          </Grid>
          <Grid item xs={12} mt={1}>
            <SoftTypography
              variant="h5"
              color="black"
              fontWeight="bold"
              sx={{
                lineHeight: 0.5,
              }}
            >
              REGISTRO CATASTRAL DE LA PLANTA
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Registro Catastral: {empresa.registroCatastral || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12} mt={1}>
            <SoftTypography
              variant="h5"
              color="black"
              fontWeight="bold"
              sx={{
                lineHeight: 0.5,
              }}
            >
              HABILITACIÓN MUNICIPAL VIGENTE
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Lugar: {empresa.habilitacionMunicipalLugar || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              N°: {empresa.habilitacionMunicipalNumero || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12} mt={1}>
            <SoftTypography
              variant="h5"
              color="black"
              fontWeight="bold"
              sx={{
                lineHeight: 0.5,
              }}
            >
              DOMICILIO LEGAL
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Calle: {declaracion.calleLegal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Código Postal: {declaracion.cpLegal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Provincia: {declaracion.provinciaLegal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Departamento: {declaracion.departamentoLegal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Localidad: {declaracion.localidadLegal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Teléfono: {declaracion.telefonoLegal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Fax: {declaracion.faxLegal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12} mt={1}>
            <SoftTypography
              variant="h5"
              color="black"
              fontWeight="bold"
              sx={{
                lineHeight: 0.5,
              }}
            >
              DOMICILIO REAL
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Calle: {declaracion.calleReal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Código Postal: {declaracion.cpReal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Provincia: {declaracion.provinciaReal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Departamento: {declaracion.departamentoReal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Localidad: {declaracion.localidadReal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Teléfono: {declaracion.telefonoReal || ""}
            </SoftTypography>
          </Grid>
          <Grid item xs={12}>
            <SoftTypography
              variant="body2"
              color="black"
              sx={{
                lineHeight: 0.5,
              }}
            >
              Fax: {declaracion.faxReal || ""}
            </SoftTypography>
          </Grid>
        </Grid>
      ) : (
        <SoftTypography color="black" variant="h6">
          No se encontraron datos de la empresa.
        </SoftTypography>
      )}
      <Firma />
    </Grid>
  );
};

export default Empresa;

Empresa.propTypes = {
  empresa: PropTypes.object,
  declaracion: PropTypes.object,
};
